module.exports = __webpack_public_path__ + "img/5.f753d5a6.png";